export default "/images/scarlet_lightbulb.png?d99279434edf5266156db450b795db02";